import * as Services from "../Services";
export interface IHeaderLogoDirectiveScope extends ng.IScope {
  headerLogoDirective: HeaderLogoDirective;
  className: string;
  hidePartnerLogo: boolean;
}

export class HeaderLogoDirective implements ng.IDirective {
  public restrict = "E";
  public scope = {
    className: "@",
    hidePartnerLogo: "=?"
  };

  public template = require("./header-logo-directive.html");

  public $scope: IHeaderLogoDirectiveScope;
  public $state: angular.ui.IStateService;

  public className: string;
  public hidePartnerLogo: boolean;
  public partner: string;

  public static $inject = ["$state", "BrandingService"];
  constructor(
    $state: angular.ui.IStateService,
    public brandingService: Services.BrandingService.IBrandingService
  ) {
    this.$state = $state;
  }

  public link = ($scope: IHeaderLogoDirectiveScope): void => {
    $scope.headerLogoDirective = this;
    this.$scope = $scope;
    this.className = $scope.className;
    this.hidePartnerLogo = $scope.hidePartnerLogo;
    this.brandingService.getLogoPathForPartner().then((data: any) => {
      this.partner = data;

      if (this.partner) {
        var loc = window.location.host

        //this will go away soon when this page is put into React
        if (loc.indexOf('solar360.int') !== -1 || loc.indexOf('localhost') !== -1) {
          this.partner = this.partner.replace('cdn/solar','cdn-int/solar')
        }
        else if (loc.indexOf('solar360.qa') !== -1) {
          this.partner = this.partner.replace('cdn/solar','cdn-qa/solar')
        }  
      }
    });
  };
}
